import { Component, OnInit } from '@angular/core';

import { SimplifiedHeaderComponent } from '../simplified-header/simplified-header.component';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-privacy-policy-page',
  standalone: true,
  imports: [SimplifiedHeaderComponent],
  templateUrl: './privacy-policy-page.component.html',
  styleUrl: './privacy-policy-page.component.scss',
})
export class PrivacyPolicyPageComponent implements OnInit {
  policyContent: SafeHtml = '';

  constructor(
    private http: HttpClient,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    this.http
      .get('assets/documents/PrivacyPolicy.html', { responseType: 'text' })
      .subscribe((content) => {
        this.policyContent = this.sanitizer.bypassSecurityTrustHtml(content);

        //this.policyContent = content;
      });
  }
}
